import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "../styles/pages/vacancies_page.css";
import Header from "../components/Header.jsx";
import Button from "../components/Button.jsx";
import Loader from "../components/Loader";
import NoImageItem from "../components/NoImageItem.jsx";
import VacancyForm from "../components/VacancyForm.jsx";
import Modal from "../components/Modal.jsx";
import { fetchVacancies, deleteVacancy } from "../services/vacanciesService";

const VacanciesPage = () => {
  const [vacanciesItems, setVacanciesItems] = useState([]);
  const [showVacancyForm, setShowVacancyForm] = useState(false);
  const [currentVacancyData, setCurrentVacancyData] = useState(null);
  const [vacancyFormMode, setVacancyFormMode] = useState("create");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [vacancyToDelete, setVacancyToDelete] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const loadVacancies = async () => {
    setIsLoading(true);
    try {
      const data = await fetchVacancies().catch((err) => {
        if (err.response?.status === 404) return [];
        throw err;
      });

      setVacanciesItems(Array.isArray(data) ? data : []);
    } catch (error) {
      if (error.response?.status === 403) {
        toast.error("Время сессии истекло, пожалуйста войдите заново", {
          position: "bottom-left",
          autoClose: 3000
        });
      } else {
        toast.error("Ошибка загрузки вакансий", {
          position: "bottom-left",
          autoClose: 3000
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadVacancies();
  }, []);

  const handleEditVacancy = (vacancy) => {
    setCurrentVacancyData(vacancy);
    setVacancyFormMode("edit");
    setShowVacancyForm(true);
  };

  const handleDeleteVacancy = (vacancy) => {
    setVacancyToDelete(vacancy);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await deleteVacancy(vacancyToDelete.id);
      await loadVacancies();
      toast.success("Вакансия успешно удалена", {
        position: "bottom-left",
        autoClose: 3000
      });
    } catch (error) {
      if (error.response?.status === 403) {
        toast.error("Время сессии истекло, пожалуйста войдите заново", {
          position: "bottom-left",
          autoClose: 3000
        });
      } else {
        toast.error("Не удалось удалить вакансию", {
          position: "bottom-left",
          autoClose: 3000
        });
      }
    } finally {
      setShowDeleteModal(false);
      setVacancyToDelete(null);
    }
  };

  const handleAddVacancy = () => {
    setCurrentVacancyData(null);
    setVacancyFormMode("create");
    setShowVacancyForm(true);
  };

  return (
    <div className="vacancies-page">
      <Header />
      <ToastContainer />

      {isLoading ? (
        <div className="loader-wrapper">
          <Loader />
          <p className="loading-text">Загрузка вакансий...</p>
        </div>
      ) : (
        <div className="vacancies-page_content">
          <div className="vacancies_section">
            <h3 className="section-title">Список актуальных вакансий</h3>
            <div className="items-container">
              {vacanciesItems.length > 0 ? (
                vacanciesItems.map((item, index) => (
                  <div key={item.id} className="numbered-item">
                    <span className="item-number">{index + 1}</span>
                    <NoImageItem
                      title={item.title}
                      onEdit={() => handleEditVacancy(item)}
                      onDelete={() => handleDeleteVacancy(item)}
                    />
                  </div>
                ))
              ) : (
                <p className="empty-list-label">Список пуст</p>
              )}
              <Button text="+ Добавить" onClick={handleAddVacancy} />
            </div>
          </div>
        </div>
      )}

      {showVacancyForm && (
        <VacancyForm
          onClose={() => setShowVacancyForm(false)}
          initialData={currentVacancyData}
          mode={vacancyFormMode}
          onSuccess={loadVacancies}
        />
      )}

      {showDeleteModal && (
        <Modal
          isOpen={showDeleteModal}
          message="Вы действительно хотите удалить вакансию:"
          itemTitle={vacancyToDelete?.title}
          onCancel={() => setShowDeleteModal(false)}
          onConfirm={handleConfirmDelete}
        />
      )}
    </div>
  );
};

export default VacanciesPage;
